import api from 'core/api'
import React, { useState } from 'react'
import { Button } from 'semantic-ui-react'

const FS_TYPES = {
  global: 'global',
  whiteLabel: 'whiteLabel'
}
export const FeatureSwitchButton = ({ whiteLabelUid, featureSwitch, on, type, onClick = () => {} }) => {
  const [loading, setLoading] = useState(false)
  const toggleFeature = async() => {
    setLoading(true)
    if (type == FS_TYPES.whiteLabel) {
      api.admin.setWhiteLabels({ whiteLabelUid, [featureSwitch]: !on})
        .then((response) => {
          setLoading(false)
          if(response.result.updated) {
            onClick({ whiteLabelUid, featureSwitch, value: !on })
          }
        })
    }

    if (type == FS_TYPES.global) {
      api.admin.setGlobalFeatureSwitches({[featureSwitch]: !on})
        .then((response) => {
          setLoading(false)
          if (response.result.updated) {
            onClick({ featureSwitch, value: !on })
          }
        })
    }
  }
  return (
    <Button
      color={on ? 'green' : 'red'}
      onClick={toggleFeature}
      loading={loading}
    >
      {featureSwitch === 'sendPremiumConversations'
      ? (on ? 'Bots' : 'Agents')
      : (on ? 'Enabled' : 'Disabled')}
    </Button>
  )
}
